<script setup>
import usePublicStore from "@/store/public";
import { useDatosCotizacion } from "@/composables/usePublic";
import { storeToRefs } from "pinia";
import CTAContactoAsesor from "@/modules/public/components/CTAContactoAsesor";
import useStoreCotizaciones from "@/store/cotizaciones";
import ArgonSwitch from "@/components/ArgonSwitch.vue";

const { listArrendamientos, listEnganches, listResiduales } = storeToRefs(
  usePublicStore()
);
const bootstrap = require("bootstrap/dist/js/bootstrap.bundle.js");
const { submitCotizacion, btnLoading } = useDatosCotizacion();
const imgAyuda = require("@/assets/img/guia_cotizacion.png");

const { arrendamiento, incluyeSeguro } = storeToRefs(useStoreCotizaciones());
const { cambiarValorIncluyeSeguro } = useStoreCotizaciones();
</script>

<template>
  <section class="py-7">
    <div class="col-md-10 mx-auto">
      <div class="col-md-7 text-center mx-auto">
        <h2>¿Qué puedo arrendar?</h2>
        <p class="text-lg text-dark">
          Desde vehículos y maquinaria para construcción,<br />
          hasta cocinas industriales y equipo médico. Arrendamos de<br />
          todas las industrias, cualquier activo que te ayude a producir más.
        </p>
      </div>
    </div>
    <div class="col-md-12 text-center">
      <img
        src="@/assets/img/Ventus/arrendamiento01.png"
        class="img-fluid"
        alt=""
      />
    </div>
  </section>

  <section>
    <form @submit.prevent="submitCotizacion" id="formCotizacion">
      <div class="row me-0">
        <div class="col-md-6 bg-light pt-5 px-4 px-md-0 pb-5 pb-mb-0">
          <div class="d-flex col-md-8 mx-auto border-bottom h-100">
            <div class="col-md-1 d-flex justify-content-center">
              <span>1</span>
            </div>
            <div class="col-md-11">
              <p>
                <b class="text-dark">Datos del proveedor del activo</b><br />
                <span class="text-dark">
                  Ingresa la información relevante sobre el proveedor del
                  activo, incluyendo el nombre de la empresa que te cotiza y
                  teléfono. Si cuentas con el nombre de tu agente de ventas y su
                  celular también ingrésalos para facilitar la comunicación y
                  coordinar mejor la compra de tu activo.
                </span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 pt-5">
          <div class="d-flex col-md-10 mx-auto">
            <div class="col-12 col-md-9 px-3 px-md-0 pb-5">
              <div class="form-group mb-4">
                <label for="empresa_proveedor" class="text-lg"
                  >Nombre de la empresa que cotiza:</label
                >
                <input
                  type="text"
                  placeholder="Ingresa el nombre de la empresa aquí"
                  class="form-control"
                  name="empresa_proveedor"
                  id="empresa_proveedor"
                  autocomplete="off"
                  required
                />
              </div>
              <div class="form-group mb-4">
                <label for="empresa_celular" class="text-lg"
                  >Teléfono de la empresa:</label
                >
                <input
                  type="tel"
                  class="form-control"
                  name="empresa_celular"
                  placeholder="Ingresa el númmero telefónico aquí"
                  id="empresa_celular"
                  autocomplete="off"
                  maxlength="10"
                  minlength="10"
                  required
                />
              </div>
              <div class="form-group mb-4">
                <label for="agente_nombre" class="text-lg"
                  >Nombre del agente de ventas:</label
                >
                <input
                  type="text"
                  placeholder="Ingresa el nombre del agente de ventas"
                  class="form-control"
                  name="agente_nombre"
                  id="agente_nombre"
                  autocomplete="off"
                  required
                />
              </div>
              <div class="form-group mb-4">
                <label for="agente_celular" class="text-lg"
                  >Teléfono celular del agente de ventas:</label
                >
                <input
                  type="tel"
                  class="form-control"
                  name="agente_celular"
                  placeholder="Ingresa el número telefónico aquí"
                  id="agente_celular"
                  autocomplete="off"
                  maxlength="10"
                  minlength="10"
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 bg-light pt-5 px-4 px-md-0 pb-5 pb-mb-0">
          <div class="d-flex col-md-8 mx-auto border-bottom h-100">
            <div class="col-md-1 d-flex justify-content-center">
              <span>2</span>
            </div>
            <div class="col-md-11">
              <p>
                <b class="text-dark">Activo y precio</b><br />
                <span class="text-dark">
                  Ingresa el activo que deseas arrendar y el precio como aparece
                  en tu cotización con IVA. Esto nos permite calcular las
                  condiciones de arrendamiento adecuadas.
                </span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 py-5">
          <div class="d-flex col-md-10 mx-auto">
            <div class="col-12 col-md-9 px-3 px-md-0">
              <div class="form-group mb-4">
                <label for="arrendamiento" class="text-lg"
                  >Activo a arrendar:</label
                >
                <select
                  name="arrendamiento"
                  id="arrendamiento"
                  class="form-control"
                  v-model="arrendamiento"
                  @change="cambiarValorIncluyeSeguro"
                >
                  <option value="">Ingresa aquí</option>
                  <option
                    :value="id"
                    v-for="{ id, nombre } in listArrendamientos"
                    :key="id"
                  >
                    {{ nombre }}
                  </option>
                </select>
              </div>
              <div class="form-group mb-4" v-if="arrendamiento == 2">
                <label for="arrendamiento" class="text-lg"
                  >Incluye seguro:</label
                >
                <div class="mt-1">
                  <argon-switch
                    :checked="incluyeSeguro"
                    @change="incluyeSeguro = !incluyeSeguro"
                  />
                </div>
              </div>
              <div class="form-group mb-4">
                <label for="importe" class="text-lg"
                  >Precio del activo (con IVA):</label
                >
                <input
                  type="tel"
                  class="form-control"
                  name="importe"
                  placeholder="Ingresa aquí"
                  id="importe"
                  autocomplete="off"
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 bg-light pt-5 px-4 px-md-0 pb-5 pb-mb-0">
          <div class="d-flex col-md-8 mx-auto border-bottom h-100">
            <div class="col-md-1 d-flex justify-content-center">
              <span>3</span>
            </div>
            <div class="col-md-11">
              <p class="pb-3">
                <b class="text-dark">Condiciones del arrendamiento</b><br />
                <span class="text-dark">
                  Selecciona las condiciones específicas de arrendamiento que
                  necesitas, como el enganche inicial, la opción de compra, y el
                  tipo de cambio, si es relevante para tu cotización.
                </span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 pb-5">
          <div class="d-flex col-md-10 mx-auto">
            <div class="col-12 col-md-9 px-3 px-md-0 pt-5">
              <div class="form-group mb-4">
                <label for="enganche" class="text-lg">Enganche:</label>
                <select name="enganche" id="enganche" class="form-control">
                  <option value="">Selecciona aquí</option>
                  <option
                    :value="porcentaje"
                    v-for="{ id, porcentaje } in listEnganches"
                    :key="id"
                  >
                    {{ porcentaje }}%
                  </option>
                </select>
              </div>
              <div class="form-group mb-4">
                <label for="residual" class="text-lg"
                  >Opción de compra**:</label
                >
                <select
                  name="residual"
                  id="residual"
                  class="form-control"
                  required
                >
                  <option value="">Selecciona aquí</option>
                  <option
                    :value="residual"
                    v-for="{ id, residual } in listResiduales"
                    :key="id"
                  >
                    {{ residual }}%
                  </option>
                </select>
              </div>
              <div class="form-group mb-4">
                <label for="moneda" class="text-lg">Tipo de cambio:</label>
                <select name="moneda" id="moneda" class="form-control" required>
                  <option value="">Selecciona aquí</option>
                  <option value="MXN">MXN</option>
                  <option value="USD">USD</option>
                  <option value="EUR">EUR</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 bg-light pb-5" v-if="showMoral">
          <div class="d-flex col-md-8 mx-auto">
            <div class="col-md-1 d-flex justify-content-center">
              <span>4</span>
            </div>
            <div class="col-md-11">
              <p class="pb-3">
                <b class="text-dark">Nombre de la empresa y RFC</b><br />
                <span class="text-dark">
                  Si estás solicitando una cotización en nombre de una empresa,
                  ingresa el nombre de la empresa y su RFC. Esto nos permite
                  comprender mejor tus necesidades comerciales y ofrecerte las
                  mejores opciones de arrendamiento.
                </span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-6 pb-5" v-if="showMoral">
          <div class="d-flex col-md-10 mx-auto">
            <div class="col-md-9">
              <div class="form-group mb-4" v-if="showMoral">
                <label for="empresa" class="text-lg">Empresa:</label>
                <input
                  type="text"
                  placeholder="Escribe aquí"
                  id="empresa"
                  name="empresa"
                  class="form-control"
                  autocomplete="off"
                  required
                />
              </div>
              <div class="form-group mb-4" v-if="showMoral">
                <label for="representante_legal" class="text-lg"
                  >Representante legal:</label
                >
                <input
                  type="text"
                  id="representante_legal"
                  name="representante_legal"
                  class="form-control"
                  autocomplete="off"
                  placeholder="Escribe aquí"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 bg-light"></div>
        <div class="col-md-6 pb-4">
          <div class="text-center col-md-9">
            <button
              class="btn btn-lg rounded-pill bg-dark text-white"
              :disabled="btnLoading"
            >
              <span
                class="spinner-border spinner-border-sm me-1"
                role="status"
                aria-hidden="true"
                v-show="btnLoading"
              ></span>
              Recibir cotización
            </button>
          </div>
        </div>
      </div>
    </form>
    <div>
      <CTAContactoAsesor />
    </div>
  </section>
</template>
